import BasicRouterView from "../../components/BasicRouterView.vue";

const office = {
  path: "bko",
  name: "backOffice",
  redirect: { name: "criarCliente" },
  meta: {
    label: "Backoffice",
    icon: "business_center",
    show: true,
    favorite: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "back-office/criar-cliente",
      name: "criarCliente",
      meta: {
        label: "Cadastrar Cliente",
        icon: "business",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/cadastrarCliente.vue"),
    },
    {
      path: "back-office/criar-entrada-banco",
      name: "criarEntradaBanco",
      meta: {
        label: "Cadastrar BD",
        icon: "storage",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/cadastrarEntradaBD.vue"),
    },
    {
      path: "back-office/cadastrar-modulo",
      name: "cadastrarModulo",
      meta: {
        label: "Cadastrar Modulo",
        icon: "book",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/cadastrarModulo.vue"),
    },
    {
      path: "back-office/cadastrar-chave",
      name: "cadastrarChave",
      meta: {
        label: "Cadastrar Chave",
        icon: "vpn_key",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/cadastrarChave.vue"),
    },
    {
      path: "back-office/autenticacao-provedor",
      name: "autenticacaoProvedor",
      meta: {
        label: "Autenticação Provedor",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/autenticacaoProvedor.vue"
        ),
    },
    {
      path: "back-office/detalhe-cliente/:clienteId",
      name: "detalheCliente",
      meta: {
        label: "Detalhe Cliente",
        icon: "person_add",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/detalheCliente.vue"),
    },
    {
      path: "back-office/permissao",
      name: "permissoes",
      meta: {
        label: "Permissões",
        icon: "playlist_add",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/Permissoes.vue"),
    },
    {
      path: "back-office/configurar-tema",
      name: "configurartema",
      meta: {
        label: "Configurar Tema",
        icon: "list",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/configurarTema.vue"),
    },
    {
      path: "back-office/termos-de-uso",
      name: "termosdeuso",
      meta: {
        label: "Termos de Uso",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/TermosDeUso.vue"),
    },
    {
      path: "back-office/detalhes-termos-de-uso:termoId",
      name: "detalhestermosdeuso",
      meta: {
        label: "Detalhes de Termos de Uso",
        icon: "assignment",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/DetalheTermoDeUso.vue"),
    },

    {
      path: "back-office/setup-integracao",
      name: "setupintegracao",
      meta: {
        label: "Setup Integração",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/SetupIntegracoes.vue"),
    },
    {
      path: "back-office/monitoramento-integracao",
      name: "monitoramentointegracoes",
      meta: {
        label: "Monitoramento Integração",
        icon: "insights",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/MonitoramentoIntegracoes.vue"
        ),
    },
    {
      path: "back-office/monitoramento-cliente-geral",
      name: "mtc-geral-teste",
      meta: {
        label: "Monitoramento Geral",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/MonitoramentoGeral.vue"),
    },
    {
      path: "backoffice/cadastro-job-cliente",
      name: "backoffice-cadastro-job-cliente",
      meta: {
        label: "Agendamento de Comando",
        icon: "app_registration",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/CadastroJobCliente.vue"),
    },
    {
      path: "backoffice/visualizacao-log-job",
      name: "backoffice-visualizacao-log-job",
      meta: {
        label: "Visualização de Logs",
        icon: "pattern",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/VisualizacaoLogJobs.vue"),
    },
    {
      path: "backoffice/lista-usuarios-teste",
      name: "backoffice-lista-usuarios-teste",
      meta: {
        label: "Lista Usuários Teste",
        icon: "person",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/ListaUsuarioTeste.vue"),
    },
    {
      path: "backoffice/fluxo-completo-teste",
      name: "backoffice-fluxo-completo-teste",
      meta: {
        label: "Fluxo Completo Teste",
        icon: "shuffle",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/FluxoCompletoTeste.vue"),
    },
    {
      path: "backoffice/nova-requisicao-balcao-teste",
      name: "backoffice-nova-requisicao-balcao-teste",
      meta: {
        label: "Nova Requisição Balcão Teste",
        icon: "add",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/NovaRequisicaoBalcaoTeste.vue"
        ),
    },
    {
      path: "backoffice/listagem-requisicoes-teste",
      name: "backoffice-listagem-requisicoes-teste",
      meta: {
        label: "Listagem de Requisições Teste",
        icon: "list",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/ListagemRequisicoesTeste.vue"
        ),
    },
    {
      path: "backoffice/requisicao-detalhe-teste/:requisicaoId",
      name: "backoffice-requisicao-detalhe-teste",
      meta: {
        label: "Listagem de Requisições Teste",
        icon: "pattern",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/RequisicaoDetalheTeste.vue"
        ),
    },
    {
      path: "backoffice/gestao-menu",
      name: "backoffice-gestao-menu",
      meta: {
        label: "Gestão de Menu",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/GestaoMenu.vue"),
    },
    {
      path: "backoffice/gestao-menu/submenu/:id",
      name: "backoffice-gestao-menu-submenu-detalhe",
      meta: {
        label: "Gestao de Menu",
        icon: "settings",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/GestaoMenuSubmenuDetalhe.vue"
        ),
    },
    {
      path: "backoffice/controle-parametrizacoes",
      name: "backoffice-controle-parametrizacoes",
      meta: {
        label: "Controle Parametrizações",
        icon: "settings",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/ControleParametrizacoes.vue"
        ),
    },
    {
      path: "backoffice/definicao-turnos",
      name: "backoffice-definicao-turnos",
      meta: {
        label: "Definição de Turnos",
        icon: "event_repeat",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "bko" */ "./views/DefinicaoTurnos.vue"),
    },
    {
      path: "backoffice/gerenciamento-chaves-facial",
      name: "backoffice-gerenciamento-chaves-facial",
      meta: {
        label: "GERENCIAMENTO DE CHAVES FACIAL",
        icon: "event_repeat",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "bko" */ "./views/GerenciamentoChavesFacial.vue"
        ),
    },
  ],
};

export default office;
